import { func } from "@/firebase";

const create_customer = func.httpsCallable("create_customer");
const create_auth_user = func.httpsCallable("create_auth_user");
const get_customers = func.httpsCallable("get_customers");
const get_users_by_customerid = func.httpsCallable("get_users_by_customerid");
const get_date = func.httpsCallable("get_date");
const load_orderstatus = func.httpsCallable("load_orderstatus");
const load_orderstatus_items = func.httpsCallable("load_orderstatus_items");
const load_customer = func.httpsCallable("load_customer");
const update_customer = func.httpsCallable("update_customer");
const simulate_order = func.httpsCallable("simulate_order");
const send_order = func.httpsCallable("send_order");

export async function getServerDate() {
  const { data } = await get_date();
  return data;
}

export async function loadOrderList(customerId, filterDays) {
  await load_orderstatus({ customerId, filterDays });
}

export async function loadOrderItems(customerId, orderNo) {
  await load_orderstatus_items({ customerId, orderNo });
}

export async function loadCustomer(customerId) {
  await load_customer({ customerId });
}

export async function getCustomers() {
  const { data } = await get_customers();
  return data;
}

export async function getUsersByCustomerId(customerId) {
  const { data } = await get_users_by_customerid({ customerId });
  return data;
}

export async function updateCustomer(customerId, customer) {
  await update_customer({ customerId, customer });
}

export async function createCustomer(customerNo, customer) {
  const { data } = await create_customer({ customerNo, customer });
  return data;
}

export async function simulateOrder(customerId, orderData) {
  const { data } = await simulate_order({ customerId, order: orderData });
  if (!data.successful && data.messages instanceof Array) {
    data.messages.forEach(msg => {
      console.warn(msg);
    });
  }
  return data;
}

export async function sendOrder(orderId, resendFlag) {
  const { data } = await send_order({ orderId, resendFlag });
  return data;
}

export async function createAuthUser(email, customerIds) {
  const { data } = await create_auth_user({ email, customerIds });
  return data;
}
